import axios from 'axios'

export const axiosWithAuth = () => {
    return axios.create({
        baseURL: 'https://potluck-planner-beapi.herokuapp.com/',/*Change this url to server end point*/ 
        headers: {
            Authorization: localStorage.getItem('token')
        }
    })
}

 